import React, { useEffect, useState } from 'react';
import { flashBarTheme } from '../../config/flashBar';
import { colors } from '../../config/constants';

interface FlashBarProps {
  isOpen: boolean;
  message: string;
  type: string;
  handleClose: () => void;
}

const FlashBar = (props: FlashBarProps) => {
  const { isOpen, message, type, handleClose } = props;
  const [flashBarType, setFlashBarType] = useState({
    color: '',
    icon: '',
  });

  useEffect(() => {
    setTimeout(() => {
      handleClose();
    }, 4000);
  }, [isOpen]);

  useEffect(() => {
    barTypeHandling();
  }, [isOpen]);

  const barTypeHandling = () => {
    if (type === flashBarTheme.SUCCESS) {
      setFlashBarType({
        ...flashBarType,
        color: 'bg-[green]',
        icon: 'fa-check',
      });
    }

    if (type === flashBarTheme.ERROR) {
      setFlashBarType({
        ...flashBarType,
        color: 'bg-[red]',
        icon: 'fa-circle-exclamation',
      });
    }
    if (type === flashBarTheme.INFO) {
      setFlashBarType({
        ...flashBarType,
        color: 'bg-[orange]',
        icon: 'fa-question',
      });
    }
  };

  return (
    <div data-testid="flashbar-wrapper">
      {isOpen ? (
        <div
          className={`fixed top-[82%] items-center flex justify-center z-[1500] w-full`}
        >
          <div className="min-h-[50px] min-w-[360px] bg-white w-fit rounded-sm mb-10 border shadow-sm flex items-center justify-between space-x-2">
            <div className="flex items-center">
              <div
                className={`min-h-[50px] w-[50px] ${flashBarType.color} flex items-center justify-center rounded-sm`}
              >
                <i
                  className={`fa-solid ${flashBarType.icon} text-[28px] text-white font-bold`}
                ></i>
              </div>
              <div className="px-2 text-[14px]">
                <div className="font-bold text-[14px] uppercase">{type}</div>
                <div className={` text-gray-500 font-normal`}>{message}</div>
              </div>
            </div>
            <div
              className="px-2 text-[14px] text-gray-500 cursor-pointer"
              data-testid="flashbar-close"
            >
              <i
                onClick={handleClose}
                className={`fa-solid fa-xmark text-[16px]`}
              ></i>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FlashBar;
